const defaults = {
    robotAction: '',
    content: '',
    lastDiscuss: null
}

export default (state = defaults, action) => {
    switch (action.type) {
        case 'ROBOT_NO_SUBSCRIBED': {
            let {time} = action.payload;
            let content = `本次课程将于${time}开始，点击顶部关注按钮，关注直播间可接收开课提醒`;
            return {...state, robotAction: 'ROBOT_NO_SUBSCRIBED', content};
        }
        case 'ROBOT_SUBSCRIBED': {
            let {time} = action.payload;
            let content = `本次课程将于${time}开始，请耐心等候`;
            return {...state, robotAction: 'ROBOT_SUBSCRIBED', content};
        }
        case 'ROBOT_COMPLAIN': {
            let content = `若对课程内容不满，可点击右下角菜单键，发起投诉，我们会有专人对你的投诉进行处理哦`;
            return {...state, robotAction: 'ROBOT_COMPLAIN', content};
        }
        case 'ROBOT_HIDE_TOP': {
            let content = `点击页面顶部的课件按钮，能再次显示PPT或视频课件哦`;
            return {...state, robotAction: 'ROBOT_HIDE_TOP', content};
        }
        case 'ROBOT_BAD_NO_BEGIN': {
            let {time} = action.payload;
            let content = `本次课程将于${time}开始，请耐心等候`;
            return {...state, robotAction: 'ROBOT_BAD_NO_BEGIN', content};
        }
        case 'ROBOT_BAD_BEGIN': {
            let content = `课程已开始，若讲师长时间没发出内容，可点击右下角菜单键，发起投诉，会有专人进行处理哦`;
            return {...state, robotAction: 'ROBOT_BAD_BEGIN', content};
        }
        case 'ROBOT_GREAT': {
            let content = `喜欢这个老师可以点击老师头像下方的“赏”，对老师进行赞赏哦`;
            return {...state, robotAction: 'ROBOT_GREAT', content};
        }
        case 'ROBOT_SET_DISCUSS': {
            return {...state, robotAction: 'ROBOT_SET_DISCUSS', lastDiscuss: action.payload};
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/robot.js